import { remarkList } from "constants/remark";

const initialState = {
  remarkList: {},
};

const remark = (state = initialState, action) => {
  switch (action.type) {
    case remarkList:
      return { ...state, remarkList: action.payload };

    default:
      return state;
  }
};
export default remark;